// https://tc39.github.io/ecma262/#sec-array.prototype.find ***POLYFILL FOR IE***
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true
    });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function(predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return -1.
            return -1;
        },
        configurable: true,
        writable: true
    });
}


function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}

class ploption {
    constructor(name, id, selected = '', disabled = false) {
        this.name = name;
        this.id = id;
        this.isSelected = selected;
        this.disabled = disabled;
    }
}

let messagetimeout = null;

function message(msg){
    let mc = $('.message-container');
    let template = `<div class="message">${msg}</div>`
    mc.html(template);
    mc.addClass('show');
    clearTimeout(messagetimeout);
    messagetimeout = setTimeout( function () {
        $('.message-container').removeClass('show')
    }, 5000)
}


let options = {
    ajaxurl: '/wp-admin/admin-ajax.php',
    apiurlbase : '/wp-json/api/v1/'
};


let currentflaseid = 0;
function getFlalseID(){
    currentflaseid--;
    return currentflaseid;
}


var pricelists = [];

function newPricelist(){
    let newpricelist = new pricelist(null);
    pricelists.push(
        newpricelist
    );
    message(translations.priceliste_erstellt );


}

function getPricelistById(id){
    return pricelists.find(function(el){
        return el.id == id;
    });
}

function getDropdownById(plid, dropdownid){
    let pricelist = pricelists.find(function(el){
        return el.id == plid;
    });
    return pricelist.plcategories.find(x=> x.datakey == dropdownid);
}

function findDropdown(el){
    return $(el).closest('.dropdown').attr('data-key');
}

function findPricelist(el){
    return $(el).closest('.pricelist').attr('data-key');
}


function init() {

    if (getQueryVariable('content') == 'all') {
        $.ajax({
            type: 'get',
            url: options.ajaxurl,
            data: {
                action: 'getPricelists',
            },
            success: function (data) {
                data = JSON.parse(data);
                console.log(data);
                data.map(pl => pricelists.push(new pricelist(pl)));
                $('.loading-icon').hide();
            }
        })
    } else {
        newPricelist();
        $('.loading-icon').hide();
    }


    //add event listeners

    //open select dropdown
    $('.pricelist-container').on('click', '.confirm-pricelist', function (e) {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        e.preventDefault();
        let pricelistid = findPricelist(this);
        pricelist = getPricelistById(pricelistid);
        pricelist.savePricelist();

    });

    //option changed
    $('.pricelist-container').on('click', '.update-option', function () {
        let optionid = $(this).attr('data-key');
        let catid = findDropdown(this);
        let pricelistid = findPricelist(this);

        let dropdown = getDropdownById(pricelistid, catid);
        dropdown.updateOptions(optionid);

    });

    //confirm changes
    $('.pricelist-container').on('click', '.confirm-change', function (e) {
        e.preventDefault();
        let dropdown = getDropdownById(findPricelist(this), findDropdown(this));
        dropdown.confirmSelection();
    });

    //function for event handling for dropdown menu

    let $opendropdown = null;

    $('.pricelist-container').on('click', '.pricelist .menu', function (e) {
        //only allow 1 menu to open at a time
        if ($opendropdown) {
            return
        }

        //show menu
        $opendropdown = $(this);
        $opendropdown.toggleClass('show');
        e.stopPropagation();

        //attach event handler for clicking outside menu
        $('body').click(function (e) {
            $opendropdown.toggleClass('show');
            $opendropdown = null;
            $('body').off('click');
            $('.menu').off('click');

        });

        //event handlers for inside menu
        $('.menu').click(function (e) {

            e.preventDefault();
            let pricelistlid = $(this).closest('.pricelist').attr('data-key');
            let dropdownid = $(this).attr('data-key');
            var pricelist = getPricelistById(pricelistlid);
            let $target = $(e.target);

            if ($target.hasClass('delete')) {
                pricelist.showConfirmDialog();
            }

            if ($target.hasClass('edit')) {
                if (pricelist.isEditShown) {
                    pricelist.closeEditView();
                } else {
                    pricelist.renderEditView();
                }
            }

            if ($target.hasClass('rename')) {
                pricelist.renamePricelist();
            }

            if ($target.hasClass('download')) {
                pricelist.download();
            }

            $opendropdown.toggleClass('show');
            $('body').off('click');
            $('.menu').off('click');
            $opendropdown = null;
            e.stopPropagation();
        })
    });

    //name change event handler
    $('input#newtitle').change(function (e) {
        var id = findPricelist(this);
        var pricelist = getPricelistById(id);
        pricelist.name = $(this).val();
    });


    //main dropddown event handler
    $('.pricelist-container').on('click', '.pricelist .nav a.list-group-item', function (e) {
        e.preventDefault();
        if ($(this).hasClass('loading')) {
            return false
        }
        let plid = findPricelist(this);
        let dropdownid = $(this).attr('data-key');
        let dropdown = getDropdownById(plid, dropdownid);
        if ($(this).hasClass('open')) {
            dropdown.closeDropdown()
        } else {
            dropdown.openDropdown()
        }
    });

    //tooltip event handeler
    $('.pricelist-container').on('mouseenter', '.pricelist .nav a.list-group-item .selected', function (e) {
        let plid = findPricelist(this);
        let dropdownid = $(this).closest('.list-group-item').attr('data-key');
        let dropdown = getDropdownById(plid, dropdownid);
        dropdown.renderTooltip(this);
    });

    $('.pricelist-container').on('mouseleave', '.pricelist .nav a.list-group-item .selected', function (e) {
        let plid = findPricelist(this);
        let dropdownid = $(this).closest('.list-group-item').attr('data-key');
        let dropdown = getDropdownById(plid, dropdownid);
        dropdown.removeTooltip();
    });

    //language selector
    $('.pricelist-container').on('click', '.pricelist .lang-select .value', function (e) {
        $(this).closest('.lang-select').toggleClass('open');
    });

    $('.pricelist-container').on('click', '.pricelist .lang-select .option', function (e) {
        let lang = $(this).html();
        $(this).closest('.lang-select').toggleClass('open');
        var id = findPricelist(this);
        var pricelist = getPricelistById(id);
        pricelist.setLanguage(lang)
        pricelist.canBeSaved();
    })


    //rename
    $('.pricelist-container').on('click', '.pricelist .newtitlesave', function (e) {
        var id = findPricelist(this);
        var pricelist = getPricelistById(id);
        let name = $(this).parent().find('input').val();
        pricelist.renamePricelistSave(name);
        $(this).hide();
        $(this).parent().find('input').hide();
    });

    //download event hander
    $('.pricelist-container').on('click', '.pricelist .download-pricelist', function (e) {
        if ($(this).hasClass('disabled')) {
            return false;
        } else {
            var id = findPricelist(this);
            var pricelist = getPricelistById(id);
            pricelist.download();
        }
    });

    //showPrices change event handler
    $('.pricelist-container').on('click', '.pricelist .price-select input', function (e) {
        var id = findPricelist(this);
        var pricelist = getPricelistById(id);
        if ( $(this).val() == 'true' ){
            pricelist.showPrices = true;
        } else { pricelist.showPrices = false; }
        pricelist.name = $('input#newtitle').val();
        pricelist.setDefaultTitle($(this).val());
        pricelist.canBeSaved();
    });

    //name change event handler
    $('input#newtitle').change(function (e) {

        var id = findPricelist(this);
        var pricelist = getPricelistById(id);
        pricelist.hasCustomTitle = true;
        pricelist.name = $(this).val();
    });
}


if ( $('.pricelist-container').length > 0 ){
    init();
}

//loginbutton handler
$('.login-status .user-button').click(function (e) {
    e.preventDefault();
    $(this).parent().find('.dropdown').toggleClass('show');
})

//for small screens
if ( $('body').width() < 1200 ){
    $('.pricelist-news-popout').removeClass('open');
}

$('.pricelist-news-popout .button').click(function () {
    $(this).closest('.pricelist-news-popout').toggleClass('open');
});

var newsitems = $('.pricelist-news-popout .ru-news-item');
var currentPage = 0;
var totalPages = 0;

if ( newsitems.length > 5 ){
    totalPages = Math.ceil(newsitems.length / 5 );

    console.log(newsitems.length);
    console.log(totalPages);

    for (var i = 0; i < totalPages; i++) {
        $('.pagination .pages').append('<span>' + (i + 1) + '</span>');
    }

    $('.pagination .next').click(function (e) {
        if ( currentPage < totalPages - 1 ){
            currentPage ++;
            paginate();
        }
    })

    $('.pagination .previous').click(function (e) {
        if ( currentPage > 0){
            currentPage --;
            paginate();
        }
    })

    $('.pagination .pages span').click(function (e) {
        currentPage = parseInt( $(this).html() - 1 );
        paginate();
    })

    paginate();

} else {
    $('.pagination').hide()
}

function paginate(){
    newsitems.hide();
    newsitems.slice( currentPage * 5, currentPage * 5 + 5 ).fadeIn();
    $('.pagination .pages span').removeClass('active');
    $('.pagination .pages span').eq(currentPage).addClass('active');
}





